module.exports = __webpack_public_path__ + "static/img/00283r.4e57a99.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/00283r.jpg
// module id = YIXJ
// module chunks = 1